const WhySection = () => {
  return (
    <div className="py-20 px-4 bg-muted/30">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            The Problem We're Solving
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            We saw a critical problem that needed solving—and we knew we could do better.
          </p>
        </div>
        
        {/* Statistics Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-card border border-border rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow">
            <div className="text-4xl md:text-5xl font-bold text-primary mb-3">14M</div>
            <div className="text-lg font-semibold text-foreground mb-2">Falls at Home</div>
            <p className="text-muted-foreground">Older Americans experience falls at home every year</p>
          </div>
          
          <div className="bg-card border border-border rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow">
            <div className="text-4xl md:text-5xl font-bold text-primary mb-3">$80B</div>
            <div className="text-lg font-semibold text-foreground mb-2">Annual Costs</div>
            <p className="text-muted-foreground">In medical expenses and lost productivity from preventable incidents</p>
          </div>
          
          <div className="bg-card border border-border rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-shadow">
            <div className="text-4xl md:text-5xl font-bold text-primary mb-3">95%</div>
            <div className="text-lg font-semibold text-foreground mb-2">Want to Stay Home</div>
            <p className="text-muted-foreground">Of seniors wish to remain in their own homes as they age</p>
          </div>
        </div>
        
        <div className="max-w-4xl mx-auto mb-16">
          <p className="text-lg text-muted-foreground leading-relaxed text-center">
            Despite this overwhelming desire to age in place, 80% of falls occur in the home environment. 
            Aging adults often face isolation, unaddressed safety hazards, and fragmented care, 
            while family caregivers become overwhelmed trying to fill the gaps.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div>
              <h3 className="text-xl font-semibold text-foreground mb-3">
                The Challenge We Identified
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                Current solutions are reactive and fragmented—emergency alerts after accidents, 
                disparate apps and devices, overwhelming complexity for families.
              </p>
            </div>
            
            <div>
              <h3 className="text-xl font-semibold text-foreground mb-3">
                The Gap We Found
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                Without proactive support, seniors face uncertainty while families worry 
                from a distance, creating stress for everyone involved.
              </p>
            </div>
          </div>
          
          <div className="bg-card border border-border rounded-lg p-8">
            <h3 className="text-xl font-semibold text-foreground mb-6">
              Our Solution
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                <p className="text-muted-foreground">Proactive prevention over reactive response</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                <p className="text-muted-foreground">Unified platform replacing fragmented solutions</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 bg-primary rounded-full mt-2 flex-shrink-0"></span>
                <p className="text-muted-foreground">Family coordination with senior independence</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhySection;